module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Grid.js"));
	}, "Grid");
}